import React from 'react';
import { motion } from 'framer-motion';

const PricingInfo = () => {
  const cardAnimation = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: [0, 0.71, 0.2, 1.01]
      }
    },
    hover: {
      scale: 1.02,
      boxShadow: "0px 5px 20px rgba(0,0,0,0.15)",
      transition: {
        duration: 0.2
      }
    }
  };

  const containerAnimation = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  // Animation pour le conteneur principal sans scale au hover
  const mainContainerAnimation = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div
      className="bg-gray-800 rounded-xl p-8 border border-gray-700"
      initial="hidden"
      animate="visible"
      variants={mainContainerAnimation}
    >
      <h2 className="text-2xl font-bold text-white mb-6 text-center">Tarification transparente</h2>
      
      <motion.div 
        className="space-y-6"
        variants={containerAnimation}
      >
        <motion.div 
          className="bg-gray-750 p-5 rounded-lg border border-gray-600 hover:bg-gray-700 transition-colors duration-300"
          variants={cardAnimation}
          whileHover="hover"
        >
          <h3 className="text-xl font-medium text-blue-400 mb-3">Comment sont établis mes tarifs ?</h3>
          <p className="text-gray-300">
            Chaque projet est unique et mérite une approche personnalisée. Je vous propose une tarification adaptée 
            à la complexité de votre projet, aux technologies utilisées et aux délais souhaités.
          </p>
        </motion.div>
        
        <motion.div 
          className="bg-gray-750 p-5 rounded-lg border border-gray-600 hover:bg-gray-700 transition-colors duration-300"
          variants={cardAnimation}
          whileHover="hover"
        >
          <h3 className="text-xl font-medium text-blue-400 mb-3">Devis gratuit et détaillé</h3>
          <p className="text-gray-300">
            Après notre premier échange sur votre projet, je vous fournis un devis gratuit et détaillé
            comprenant les différentes étapes du projet, les fonctionnalités et le budget estimé.
          </p>
        </motion.div>
        
        <motion.div 
          className="bg-gray-750 p-5 rounded-lg border border-gray-600 hover:bg-gray-700 transition-colors duration-300"
          variants={cardAnimation}
          whileHover="hover"
        >
          <h3 className="text-xl font-medium text-blue-400 mb-3">Forfaits maintenance</h3>
          <p className="text-gray-300">
            Je propose des forfaits de maintenance adaptés à vos besoins pour garantir la pérennité 
            de votre projet, incluant les mises à jour, corrections et améliorations.
          </p>
        </motion.div>
      </motion.div>
      
      <div className="mt-8 text-center">
        <p className="text-gray-400 italic">
          Pour des informations précises sur les tarifs adaptés à votre projet, n'hésitez pas à me contacter.
        </p>
      </div>
    </motion.div>
  );
};

export default PricingInfo;
